export default __webpack_public_path__ + "static/media/logo-purple.2ca7ad17.png";